import TextField from '@mui/material/TextField';
import {useField} from 'formik';
import PropTypes from 'prop-types';

const AppTextField = ({readonly, rows, ...props}) => {
  const [field, meta] = useField(props.name);
  const errorText = meta.error && meta.touched ? meta.error : '';

  return (
    <TextField
      fullWidth
      {...props}
      {...field}
      value={field.value ?? ''}
      helperText={errorText}
      error={!!errorText}
      multiline={rows > 0}
      rows={rows}
      InputProps={{
        readOnly: readonly,
        style: {height: 'auto'},
      }}
    />
  );
};

AppTextField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,

  placeholder: PropTypes.string,
  type: PropTypes.string, // e.g., 'password', 'email', 'text'
  readonly: PropTypes.bool,
  rows: PropTypes.number,
};

export default AppTextField;
